import { isNil, noop } from 'lodash';
import React, { useContext, useState } from 'react';
import { useModalState } from 'hooks/useModalState';
import ButtonComponent from 'components/Button';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import { SearchOutlined } from '@ant-design/icons';
import { AuthContext } from 'components/Auth/Auth';
import ThirdPartySearchModal from 'pages/ThirdParty/ThirdPartySFS/ThirdpartySearch/ThirdPartySearchModal';
export type ThirdPartyForProposalType = {
  tpid?: number;
  tpreference?: string;
  tpname?: string;
};

export type ThirdPartyInputProps = {
  onChange?: any;
  onSelected?: (value: ThirdPartyForProposalType) => void;
  value?: ThirdPartyForProposalType;
  role?: string;
  parentid?: number;
  zindex?: number;
  isCreate?: boolean;
  onlytpid?: boolean;
  display?: boolean;
  style?: any;
  hideSearchButton?: boolean;
  disabled?: boolean;
  parcodeRole?: string;
  clear?: boolean;
  styleprops?: React.CSSProperties;
  EntityDataByid?: boolean;
  valueToDisplay?: ThirdPartyForProposalType;
  tptype?: string;
  tpid?: number
};

const ThirdPartyInput = ({
  onChange = noop,
  onSelected,
  value,
  role,
  parentid,
  isCreate,
  onlytpid,
  style,
  parcodeRole,
  tptype,
  tpid
}: ThirdPartyInputProps) => {
  const [Params, setParams] = useState<ThirdPartyForProposalType>({
    tpid: value?.tpid,
    tpreference: value?.tpreference,
    tpname: value?.tpname,
  });

  const { visible, close, open } = useModalState(false);
  const [tpModal, setTpModal] = useState(false);

  const handleSelect = (item: any) => {
    if (onSelected)
      onSelected({
        tpreference: item?.tpreference,
        tpname: item.tpname,
        tpid: item?.tpid,
      });

    setParams({
      tpreference: item?.tpreference,
      tpname: item.tpname,
      tpid: item?.tpid,
    });

    onlytpid ? onChange(item?.tpid) : onChange(item);

    close();
  };

  const hideThirdPartyModal = () => {
    setTpModal(false);
    close();
  };


  const { isInspect } = useContext(AuthContext);


  return (
    <>
      <div style={style}>


        <ButtonComponent
          onClick={() => {
            !isInspect &&
              open();
          }}
          icon={isInspect && <SearchOutlined onClick={() => {
            open();
          }} />}
          type="primary"
          comcode="searchtp"
          className='btn-header'
          id="searchbtntp"
        />
      </div>

      <ThirdPartySearchModal
        tpid={tpid}
        initialSearchParams={{ role, parentid, tptype }}
        visible={visible}
        onCancel={() => {
          localStorage.removeItem('searchParams');
          close();
        }}
        onSelect={handleSelect}
        isProposalCreate={Boolean(isCreate)}
        setThirdPartyForProposal={setParams}
        hideThirdPartyModal={hideThirdPartyModal}
        parcodeRole={parcodeRole}
      />
      {value?.tpid || isCreate ? (
        <ThirdPartyModal
          onSelect={(item) => {
            handleSelect(item.generalData);
          }}
          iscreate={isCreate}
          title={
            onlytpid && !value?.tpid
              ? Params?.tpid && !isNil(value)
                ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                : isCreate
                  ? 'Create a Thirdparty....'
                  : 'Select a ThirdParty'
              : value?.tpid && !isNil(value)
                ? `${value.tpreference ?? ''}  -  ${value.tpname ?? ''}`
                : isCreate
                  ? 'Create a Thirdparty....'
                  : Params?.tpid && !isNil(value)
                    ? `${Params.tpreference ?? ''}  -  ${Params.tpname ?? ''}`
                    : 'Select a ThirdParty'
          }
          tpId={value?.tpid ?? 0}
          visible={tpModal}
          onCancel={() => setTpModal(false)}
          hideThirdPartyModal={hideThirdPartyModal}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ThirdPartyInput;
